import classNames from "classnames";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useContext } from "react";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { IUserMeeting } from "../../app/models/meeting";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import DownloadErrorToast from "../toast/DownloadErrorToast";

interface IParams {
  meeting: IUserMeeting;
  tenant: ITenant;
  cardType: string;
  btnClassName?: string;
}

const SaveOfflineMeetingButton: React.FC<IParams> = ({ meeting, tenant, cardType, btnClassName }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    saveMeetingToDb,
    alreadyDownloadedMeetingIds,
    addAlreadyDownloadedMeetings,
    currentDownloadingMeetingId,
    setCurrentDownloadingMeetingId,
    isDownloadInProgress
  } = rootStore.offlineStore;
  const { theme } = rootStore.commonStore;

  const handleClick = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    if (!isDownloadInProgress) {
      setCurrentDownloadingMeetingId(meeting.id);
      await saveMeetingToDb(meeting, tenant)
        .then(() => addAlreadyDownloadedMeetings(meeting))
        .catch(() => {})
        .finally(() => setCurrentDownloadingMeetingId(null));
    } else
      toast.error(
        (props) =>
          DownloadErrorToast({
            type: "inProgress",
            toastContentProps: props,
          }),
        { toastId: `DownloadInProgress` }
      );
  };

  const getIconClassNames = () => {
    if (currentDownloadingMeetingId === meeting.id) return "fa-spinner fa-spin";
    else if (alreadyDownloadedMeetingIds.has(meeting.id)) {
      const savedDate = alreadyDownloadedMeetingIds.get(meeting.id);
      if (savedDate && moment(savedDate).isBefore(meeting.lastUpdateDate, "minute"))
        return "fa-exclamation-triangle";
      else return "fa-check";
    } else return "fa-cloud-download-alt";
  };

  const getCardTypeTheme = () => {
    switch(cardType)
  {
    case "presente":{
      return `${theme?.saveOfflineMeetingButtonActive}`
    }
    case "passato":{
      return `${theme?.saveOfflineMeetingButtonPast}`
    }
    case "futuro":{
      return `${theme?.saveOfflineMeetingButtonFuture}`
    }
  }
  }

  return (
    <Button className={btnClassName?? ""} onClick={(e) => handleClick(e)}><i
      className={classNames("fas fa-lg salvaOffline float-left mr-auto", getIconClassNames(), getCardTypeTheme())}
    ></i>
    </Button>
  );
};

export default observer(SaveOfflineMeetingButton);
